

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import customStyles from "../../../../../assets/styles/customStyles";
import { PriceCustomerListHead } from "../../../../../config/constant";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { getColumnWidth, capitalizeFirstLetter } from "../../../../../helpers/utilities";


export const CustomerListView = (props) => {
    const { onRequestSort, sortOrder, sortBy, view,
        details, loadMore, loadMoreContent, loadMoreTask, selected, handleSelected } = props;

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={view ? PriceCustomerListHead.slice(1) : PriceCustomerListHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            selected={selected}
            onSelected={(value) => handleSelected(value)}
            width={true}
            details={details && details.filter((el) => { return el.inAppStatus === 'ACCEPTED' })}

            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.positionRelative}
                                                style={{ width: getColumnWidth(PriceCustomerListHead, 0) }}>
                                                <div style={{ width: getColumnWidth(PriceCustomerListHead, 0) }}
                                                    className={clsx(classes.positionRelative)}>
                                                    {data?.customer?.name}</div>
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 1) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 1) }}>{data?.customer?.serialNo || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}>{data?.customer.mobile}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(PriceCustomerListHead, 3) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}>{data?.customer?.customerBusiness?.serialNo}</span></TableCell>
                                            <TableCell className={classes.textAlignLeft} style={{ width: getColumnWidth(PriceCustomerListHead, 4) }}><span style={{ width: getColumnWidth(PriceCustomerListHead, 2) }}>{data?.customer?.inAppStatus ? capitalizeFirstLetter(data?.customer?.inAppStatus) : 'Rejected'}</span></TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>No results found</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}